import React from "react";

export default ({ submit, inputs, menu }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        marginLeft: "250px",
        paddingBottom: "400px",
      }}
    >
      <div
        className="container"
        style={{
          paddingLeft: "35px",
          paddingRight: "35px",
          paddingTop: "20px",
        }}
      >
        <h1 className="font-weight-bold">Edit Outlet</h1>
        <div className="col">
          <form
            onSubmit={(e) => submit(e)}
            style={{
              padding: "40px",
              marginRight: "20px",
            }}
          >
            <div
              className="form-group"
              style={{
                paddingBottom: "20px",
              }}
            >
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="name"
                type="text"
                className="form-control"
                placeholder="Outlet name..."
                required
                value={menu.name}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Image of Menu
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="imageOutlet"
                type="text"
                className="form-control"
                placeholder="URL Image"
                required
                value={menu.imageOutlet}
              />

<label
                style={{
                  marginTop: "20px",
                }}
              >
                Order Number
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="order"
                type="text"
                className="form-control"
                placeholder="1, 2, 3..."
                required
                value={menu.order}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#FF2068",
                borderColor: "#FF2068",
              }}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
